import axios from 'axios';

import {
    GOOGLE_PAY_PAYMENT,
    GOOGLE_PAY_PAYMENT__FAILURE,
    // GOOGLE_PAY_PAYMENT__RESET,
} from './actions';

function getGooglePay(error) {
    return {
        type: GOOGLE_PAY_PAYMENT,
        error,
    };
}

function getGooglePayFailure(error) {
    return {
        type: GOOGLE_PAY_PAYMENT__FAILURE,
        error,
    };
}

const getMakeGooglePay = ({ dispatch, token, paymentData }) => axios.post(
    `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/pay/makeGooglePay/${token}`,
    {
        data: {
            id: paymentData.id,
            cryptogram: btoa(paymentData.tokenizationData.token),
            signature: JSON.parse(paymentData.tokenizationData.token).signature,
            preauth: 'N',
            email: paymentData.email,
        },
    }, {
        headers: { 'Content-Type': 'application/json' },
    },
).then(response => {
    const serverRedirect = response?.request?.responseURL;
    if (response.status === 200 && response.data && !serverRedirect) {
        const {
            data: {
                error,
                errorMessage,
            },
        } = response;
        if (error || errorMessage) {
            throw new Error(error || errorMessage);
        }
        const { status, redirectURL } = response.data;

        if (redirectURL && ((status === 1) || (status === 2))) {
            window.location.href = redirectURL;
        }
    }

    if (response.status === 200 && serverRedirect) {
        window.location.href = serverRedirect;
    }

    throw new Error('Ошибка сервера');
})
    .catch(error => {
        const errorMessgage = error.message || 'Ошибка сервера';
        dispatch(getGooglePayFailure(new Error(errorMessgage)));
        return { error: errorMessgage };
    });

const makeGooglePay = async (dispatch, { token, paymentData }) => {
    dispatch(getGooglePay());
    await getMakeGooglePay({ dispatch, token, paymentData });
    return true;
};

export function startGooglePay(paymentData) {
    return (dispatch) => {
        const url = document.location.href;
        const parsedUrl = new URL(url);
        const token = parsedUrl.pathname.replace(
            `${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '',
        );

        const data = {
            paymentData,
            token,
        };
        makeGooglePay(dispatch, data);
    };
}
